import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table } from 'src/components';
import newAlert from 'src/components/newAlert';
import { useQuery, replaceFloat } from 'src/core/utils/formater';
import { Modal, Input, Button, Form, Select } from 'antd';
import {
  columns,
  customSummary,
  MulticustomSummary,
} from './dataStructure/data';
import { start_loading, end_loading } from '../../../core/actions/loader';

const PageData = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { socket, month, year } = useSelector((state) => ({
    socket: state.socket,
    month: state.data_date?.month,
    year: state.data_date?.year,
  }));
  const data_date = useSelector((state) => state.data_date);
  const [summary, seTsummary] = useState({});
  const [tableData, setTableData] = useState([]);
  const [total, seTtotal] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const query = useQuery();
  const page = query.get('page');
  const size = query.get('size');

  const showEditModal = (row) => {
    setEditRowId(row.id);
    form.setFieldsValue({
      percent: row.huuli_7_1_2,
      uls_ners: row.uls_ners || '',
      certificate: row.certificate || false,
    });
    setIsModalVisible(true);
  };

  const generateTailan = () => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        setTableData(data?.content?.table_data);
        seTsummary(data?.content?.sum_data);
        seTtotal(data?.content?.total);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });

    socket.emit('request_in', {
      channel: 'hh01_view',
      content: {
        action_type: 'get_hm13_data',
        page,
        size,
        search: {},
        month,
        year,
      },
    });
    dispatch(start_loading({}));
  };

  const send_rows = () => {
    const rows = selectedRowKeys
      .map((key) => tableData.find((item) => item.id === key))
      .filter(Boolean);

    if (rows.length === 0) {
      newAlert({ type: 'warning', msg: 'Сонгосон мөр байхгүй байна' });
      return;
    }

    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      if (status === 0) {
        newAlert({
          type: 'success',
          msg: content?.Message,
          functions: { Success: [generateTailan()] },
        });
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });

    socket.emit('request_in', {
      channel: 'hh01_modify',
      content: {
        action_type: 'transfer_hm13_data',
        selected_rows: rows,
        year,
        month,
      },
    });

    dispatch(start_loading({}));
  };

  const handleSave = (values) => {
    const { percent, certificate, uls_ners } = values;

    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      if (status === 0) {
        setIsModalVisible(false);
        newAlert({ type: 'success', msg: content?.Message });
        generateTailan();
      } else {
        newAlert({ type: 'error', msg: content?.Message });
      }
      dispatch(end_loading({}));
    });

    socket.emit('request_in', {
      channel: 'hh01_modify',
      content: {
        action_type: 'update_hm13_data',
        id: editRowId,
        percent: replaceFloat(percent),
        certificate,
        uls_ners,
        year,
        month,
      },
    });

    dispatch(start_loading({}));
  };

  useEffect(() => {
    setSelectedRowKeys([]);
    if (data_date) {
      generateTailan();
    }
  }, [data_date]);

  const TableTitle = () => (
    <div style={{ marginBottom: '16px' }}>
      <Button
        disabled={selectedRowKeys.length === 0}
        className="confirm-btn ml-5"
        type="primary"
        size="small"
        onClick={send_rows}
        style={{ marginRight: '8px' }}
      >
        ХМ11-1 руу буцаах
      </Button>
    </div>
  );

  return (
    <>
      <Modal
        title="Хуулийн 7.1.2 Засварлах"
        open={isModalVisible}
        onOk={() => form.validateFields().then(handleSave)}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        okText="Хадгалах"
        cancelText="Цуцлах"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Улсын нэрс"
            name="uls_ners"
            rules={[{ required: true, message: 'Улсын нэр заавал оруулна уу' }]}
          >
            <Input.TextArea placeholder="Улсын нэр оруулна уу" rows={1} />
          </Form.Item>

          <Form.Item
            label="Хувь (%)"
            name="percent"
            rules={[
              { required: true, message: 'Хувийг заавал оруулна уу' },
              { pattern: /^\d+(\.\d+)?$/, message: 'Тоон утга оруулна уу' },
              {
                validator: (_, value) =>
                  value === undefined || value === ''
                    ? Promise.resolve()
                    : value >= 0 && value <= 100
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error('Хувь 0-100 хооронд байх ёстой')
                      ),
              },
            ]}
          >
            <Input placeholder="Хувь оруулна уу" suffix="%" />
          </Form.Item>

          <Form.Item
            label="Сертификаттай эсэх"
            name="certificate"
            rules={[{ required: true, message: 'Сонголт хийх шаардлагатай' }]}
          >
            <Select>
              <Select.Option value>Тийм</Select.Option>
              <Select.Option value={false}>Үгүй</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <div className="custom-hoat-table">
        <Table
          title={TableTitle}
          rowKey="id"
          total={total}
          rowSelection={
            month && String(month).split(',').length === 1
              ? {
                  selectedRowKeys,
                  onChange: setSelectedRowKeys,
                  hideSelectAll: true,
                  getCheckboxProps: (record) => ({
                    disabled: record.someCondition === false,
                  }),
                }
              : null
          }
          columns={columns({
            showEditModal,
            shouldRenderEditColumn:
              month && String(month).split(',').length === 1,
          })}
          dataSource={tableData.map((row) => ({ ...row, key: row.id }))}
          scroll={{ y: 'calc(100vh - 280px)' }}
          summaryList={{
            sumColumn:
              month && String(month).split(',').length === 1
                ? customSummary
                : MulticustomSummary,
            sumDataSource: summary,
          }}
        />
      </div>
    </>
  );
};

export default PageData;
